import { getExtendedOrder } from "@husky-hrc/Framework/Services/ProductConfigServiceV1";
import { CustomCartModel, CustomOrderModel } from "@husky-hrc/Framework/Types/ApiModel";
import { enableHMRForChain } from "@husky-hrc/Utilities/Utilities";
import isApiError from "@insite/client-framework/Common/isApiError";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain as cartChain, GetCart } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";

enableHMRForChain(chain);

type loadOrderByOrderNumberProps = Parameters<typeof RequestDataFromApi>[0];
type loadCurrentCartProps = Parameters<typeof GetCart>[0];

export const GetExtendedOrder = async (props: loadOrderByOrderNumberProps) => {
    props.apiParameter = {
        orderNumber: props.parameter.orderNumber,
        expand: [],
    };

    try {
        const extendedOrderCollection = await getExtendedOrder(props.apiParameter);
        (props.apiResult as CustomOrderModel).spares = extendedOrderCollection.spares;
        (props.apiResult as CustomOrderModel).options = extendedOrderCollection.options;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.dispatch({
                type: "Data/Orders/FailedToLoadOrder",
                orderNumber: props.parameter.orderNumber,
                status: 404,
            });
            return false;
        }
        throw error;
    }
};

export const GetExtendedCart = async (props: loadCurrentCartProps) => {
    const apiParameter = {
        orderNumber: props.apiResult.cart.orderNumber,
        expand: [],
    };

    if (apiParameter.orderNumber) {
        try {
            const extendedOrderCollection = await getExtendedOrder(apiParameter);
            (props.apiResult.cart as CustomCartModel).spares = extendedOrderCollection.spares;
            (props.apiResult.cart as CustomCartModel).options = extendedOrderCollection.options;
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                props.dispatch({
                    type: "Data/Carts/FailedToLoadCart",
                    cartId: props.apiParameter.cartId,
                    status: 404,
                });
                return false;
            }
            throw error;
        }
    }
};

addToChainAfter(chain, RequestDataFromApi, GetExtendedOrder);
addToChainAfter(cartChain, GetCart, GetExtendedCart);
